<!-- //
dialog:商城-地区-编辑
@auth xuyd
@date 2024-10-01
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      top="10vh"
      width="600px">
    <div>
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="130px" class="form">
        <el-row class="flow-row">
          <el-form-item prop="name" label="地区名">
            <el-input v-model="form.name" clearable :disabled="!editable" @change="handlePinyin"/>
          </el-form-item>
          <el-form-item prop="pinyin" label="拼音">
            <el-input v-model="form.pinyin" clearable :disabled="!editable"/>
          </el-form-item>
          <el-form-item prop="shortName" label="地区简称">
            <el-input v-model="form.shortName" clearable :disabled="!editable"/>
          </el-form-item>
          <el-form-item prop="code" label="编码">
            <el-input v-model="form.code" clearable :disabled="!editable"/>
          </el-form-item>
          <el-form-item prop="pcode" label="父级编码">
            <el-input v-model="form.pcode" clearable :disabled="!editable"/>
          </el-form-item>
          <el-form-item prop="longitude" label="经度">
            <el-input v-model="form.longitude" clearable :disabled="!editable"/>
          </el-form-item>
          <el-form-item prop="latitude" label="维度">
            <el-input v-model="form.latitude" clearable :disabled="!editable"/>
          </el-form-item>
<!--          <el-form-item prop="level" label="层级(从1开始)">-->
<!--            <el-input v-model="form.level" clearable :disabled="!editable"/>-->
<!--          </el-form-item>-->
          <el-form-item prop="leafFlag" label="是否叶子节点">
            <el-switch v-model="form.leafFlag" :active-value="1" :inactive-value="0"/>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideModal">取 消</el-button>
      <el-button type="primary" size="small" @click="handleOk" :loading="loading">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import RegionApi from '@/api/mall/region.api.js';
import CommonApi from "@/api/mall/common.api";

const FORM_DEFINE = {
  code: null,
  name: null,
  pcode: null,
  pinyin: null,
  longitude: null,
  latitude: null,
  level: null,
  leafFlag: 0,
  shortName: null,
};
export default {
  name: 'ViewMallComMgmtRegionDetail',
  dictTypes: [
    {dictType: 'YES_OR_NO', dataType: Number},
  ],
  data() {
    return {
      loading: false,
      visible: false,
      title: '新增',
      opts: {
        mode: null,
      },
      form: this.$util.mergeObject(FORM_DEFINE),
      rules: {
        name: [{required: true, message: "请输入地区名", trigger: 'blur'}],
        code: [{required: true, message: "请输入地区编码", trigger: 'blur'}],
        pcode: [{required: true, message: "请输入地区父级编码", trigger: 'blur'}],
        leafFlag: [{required: true, message: "请选择是否是叶子节点", trigger: 'change'}],
      },
    }
  },
  computed: {
    editable() {
      return this.opts.mode === 1 || this.opts.mode === 2;
    }
  },
  methods: {
    showModal({data, mode, title, onOk}) {
      let that = this;
      this.dialogShow({
        data: data,
        mode: mode,
        title: title,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    dialogShow(opts) {
      console.log("===========>", opts)
      this.visible = true;
      this.opts.mode = opts.mode
      this.opts.onOk = opts.onOk
      this.opts.onCancel = opts.onCancel
      if (!opts.data) {
        opts.data = {};
      }
      opts.data = this.$util.mergeObject(FORM_DEFINE,  opts.data)
      this.form = opts.data
      this.title = opts.title
    },

    hideModal() {
      this.visible = false;
      this.$refs["refForm"].clearValidate();
      this.$refs["refForm"].resetFields();
    },

    /**
     * 处理拼音
     * @param val
     */
    handlePinyin(val) {
      CommonApi.chinese2pinyin(val).then(resp => {
        this.form.pinyin = resp.data.pinyin;
      });
    },

    /**
     * 点击确定
     */
    handleOk() {
      let data = {...this.form};
      this.$refs.refForm.validate(valid => {
        if (valid) {
          this.loading = true;
          return RegionApi.saveRegion(data).then(resp => {
            this.loading = false;
            this.$modal.msgSuccess("保存成功")
            this.opts.onOk(resp.data);
            this.hideModal();
          }).catch(() => {
            this.loading = false;
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.form {
  padding-right: 50px;
}
</style>
